import { Skeleton, Stack, SxProps } from "@mui/material";

interface IProps {
  sx?: SxProps;
}

const TextResponseSkeleton = (props: IProps) => {
  return (
    <Stack spacing={0.5} sx={props.sx}>
      <Skeleton variant="rectangular" height={24} width={120} />
      <Skeleton variant="rectangular" height={24} width={150} />
      <Skeleton variant="rectangular" height={72} />
    </Stack>
  );
};

export { TextResponseSkeleton };
